(function () {

    'use strict';

    angular.module('Services').factory('patternFactory', patternFactory);

    function patternFactory() {
        const decimal = '^(?=.*[0-9])\\d{0,15}(?:\\.\\d*)?$';
        const noZeroDecimal = '^(?=.*[1-9])\\d{0,15}(?:\\.\\d*)?$';
        const email = '^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$';
        const wholeNumber = '^([0-9]*)$';
        const noZeroWholeNumber = '^([1-9]*)$';
        return {
            decimal,
            noZeroDecimal,
            email,
            wholeNumber,
            noZeroWholeNumber
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/Factories/patternFactory.js